module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/icon_hibiscus-14d203f4a12ba9dfb0fbc86285ad21b4.png";